import React from 'react'
import { TicketsList } from './list/page'

export const NewYear2026TicketsPage = () => {
  return <TicketsList />
}
